module.exports = __webpack_public_path__ + "static/media/yolo2.a6cfaa39.gif";